import type { IComponentController } from "angular";
import type { IGuardCompany } from "App/Modules/Models/Models/IGuardCompany";

export default class SiteConfigurationGroupGuardCompaniesInfoComponentController implements IComponentController {
    public static $inject: string[] = [];

    public guardCompaniesList: IGuardCompany[];
}
